import type { FunctionComponent } from "react"

import { Callout } from "@jobteaser/spark/components/Callout"
import { Text } from "@jobteaser/spark/components/Text"

import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./StatusDeclined.module.css"

export const StatusDeclined: FunctionComponent = () => {
  const { t } = useTranslation(["event_details"])

  return (
    <Callout className={styles.main} data-testid="event-details-registration-details-status-declined" variant="error">
      <Text data-testid="event-details-registration-details-status-declined-title" variant="body1" weight="bold">
        {t(`event_details.status.declined`)}
      </Text>
      <Text data-testid="event-details-registration-details-status-declined-text" variant="body1">
        {t(`event_details.status.declined_message`)}
      </Text>
    </Callout>
  )
}
